<!-- SPDX-License-Identifier: GPL-3.0-or-later -->
<script lang="ts">
  import type { ConnectionStatus } from '@ffb/shared';
  import StatusDot from '../atoms/StatusDot.svelte';

  interface Props {
    status: ConnectionStatus;
  }

  let { status }: Props = $props();

  const config: Record<
    ConnectionStatus,
    { label: string; tone: 'neutral' | 'warning' | 'success' | 'danger'; pulse: boolean }
  > = {
    initializing: { label: 'Инициализация', tone: 'neutral', pulse: false },
    'requesting-mic': { label: 'Микрофон…', tone: 'warning', pulse: false },
    connecting: { label: 'Соединение', tone: 'warning', pulse: false },
    connected: { label: 'В эфире', tone: 'success', pulse: true },
    error: { label: 'Ошибка', tone: 'danger', pulse: false },
  };

  const current = $derived(config[status]);
</script>

<div class="flex items-center gap-2 bg-white/5 border border-white/10 rounded-full px-3 py-1.5">
  <StatusDot tone={current.tone} pulse={current.pulse} />
  <span class="text-xs text-slate-300 font-medium">{current.label}</span>
</div>
